export default __webpack_public_path__ + "static/media/plug.b6856d1b.jpg";